(() => {
  let busy = false;
  let previousProgress;
  class BFShippingProgress extends HTMLElement {
    connectedCallback() {
      const target = Math.min(Number(this.dataset.count), 2) / 2;
      const fill = this.querySelector('.bf-progress__track span');
      if (previousProgress !== undefined && previousProgress !== target && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        fill.style.transform = 'scaleX(' + previousProgress + ')';
        requestAnimationFrame(() => requestAnimationFrame(() => { if (this.isConnected) fill.style.transform = 'scaleX(' + target + ')'; }));
      }
      previousProgress = target;
    }
  }
  if (!customElements.get('bf-shipping-progress')) customElements.define('bf-shipping-progress', BFShippingProgress);
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-bf-scroll]');
    if (!arrow) return;
    const rail = arrow.closest('.bf-upsell').querySelector('.bf-upsell__rail');
    rail.scrollBy({left: Number(arrow.dataset.bfScroll) * rail.clientWidth * .9, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.bf-add-form');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const button = form.querySelector('button');
    const error = form.querySelector('.bf-form-error');
    error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    drawer.setActiveElement(document.activeElement);
    const data = new FormData(form);
    data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.append('sections_url', window.location.pathname);
    try {
      const response = await fetch(window.routes.cart_add_url, {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || window.cartStrings.error);
      if (!state.sections || !state.sections['cart-drawer']) { window.location.assign(window.routes.cart_url); return; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
      document.dispatchEvent(new CustomEvent('bf:cart-updated'));
    } catch (issue) {
      error.textContent = issue.message || window.cartStrings.error;
      error.hidden = false;
    } finally {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();